import React, { Fragment, useMemo } from 'react';

import { Avatar, Box, Collapse, Divider, Group, Stack, Text, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronRight } from '@tabler/icons-react';
import { AthleteAppointmentAthleteRetrieve, AthleteKiloClassAthleteRetrieve } from 'types';

const AthleteListSection = ({
  athleteKiloClasses,
  athleteAppointments,
}: {
  athleteKiloClasses?: AthleteKiloClassAthleteRetrieve[];
  athleteAppointments?: AthleteAppointmentAthleteRetrieve[];
}): JSX.Element => {
  const theme = useMantineTheme();

  const [isOpened, { toggle: toggle }] = useDisclosure();

  const reservedAthleteEvents = useMemo(():
    | AthleteAppointmentAthleteRetrieve[]
    | AthleteKiloClassAthleteRetrieve[] => {
    if (!!athleteKiloClasses) {
      return athleteKiloClasses.filter(akc => akc.isReserved && !akc.isLateCancel && !akc.isNoShow);
    }
    if (!!athleteAppointments) {
      return athleteAppointments.filter(aa => aa.isReserved && !aa.isLateCancel && !aa.isNoShow);
    }
    return [];
  }, [athleteAppointments, athleteKiloClasses]);

  return (
    <Box>
      <Group noWrap onClick={toggle} spacing='xs'>
        <Text color='dimmed' fs='italic'>
          Reserved Athletes
        </Text>
        <IconChevronRight
          color={theme.colors.dark[3]}
          size={theme.fontSizes.lg}
          style={{
            transform: isOpened ? 'rotate(90deg)' : 'unset',
            transition: 'ease-in 100ms',
          }}
        />
      </Group>
      <Collapse in={isOpened} transitionTimingFunction='linear'>
        <Stack spacing='xs' px='xl' pt='lg'>
          {reservedAthleteEvents.length === 0 && <Text>No Reserved Athletes</Text>}
          {reservedAthleteEvents.length > 0 &&
            reservedAthleteEvents.map(
              ({ athlete }, index) =>
                athlete && (
                  <Fragment key={athlete.athleteId}>
                    {index !== 0 && <Divider />}
                    <Group spacing='sm'>
                      <Avatar src={athlete.profilePicture} size='md' radius='xl' color='kiloBlue' />
                      <Text fw={500}>{athlete.fullName}</Text>
                    </Group>
                  </Fragment>
                ),
            )}
        </Stack>
      </Collapse>
    </Box>
  );
};

export default AthleteListSection;
